/** 一括操作バー（README ①d）。1件以上選択中のみ表示 */
export function BulkBar({
  count,
  busy,
  onNudge,
  onCopyUrls,
  onBack,
  onClear,
}: {
  count: number;
  busy: boolean;
  onNudge: () => void;
  onCopyUrls: () => void;
  onBack: () => void;
  onClear: () => void;
}) {
  return (
    <div className="gf-bulk" role="toolbar" aria-label="一括操作">
      <span className="gf-bulk-n">{count}件を選択中</span>
      <button type="button" className="gf-bulk-btn" disabled={busy} onClick={onNudge}>
        催促を記録
      </button>
      <button type="button" className="gf-bulk-btn" disabled={busy} onClick={onCopyUrls}>
        フォームURLをコピー
      </button>
      <button type="button" className="gf-bulk-btn" disabled={busy} onClick={onBack}>
        段階を戻す
      </button>
      <button type="button" className="gf-bulk-clear" onClick={onClear}>
        選択解除
      </button>
    </div>
  );
}
